var r=function(r){try{return r()}catch(r){return}};export{r as safeProbe};
//# sourceMappingURL=safe.js.map
